module.exports = __webpack_public_path__ + "img/KC_BG2.3c4dfe7e.png";